import useGetAccount from './useGetAccount'

/**
 * Returns true when the team has the RBAC Roles tab enabled in the backend
 * (toggled by superadmins in Django admin: `team.settings.roles_tab_enabled`).
 *
 * Drives the locked state of the Roles tab (Header + page teaser) and keeps
 * the Team-section landing redirect off the locked page. Role-definition
 * writes are also enforced server-side by the same flag; role/catalog READS
 * stay open (member pickers, grant picker depend on them).
 */
const useGetIsRolesTabEnabled = (): boolean => {
  const account = useGetAccount()
  // `!!` collapses the loading state (account undefined) to false, so the tab
  // reads as locked until the account resolves. Safe: the Team area renders
  // only under AuthRoute/AuthLayout, which block until the account query
  // resolves — this never mounts mid-load.
  return !!account?.team?.settings?.roles_tab_enabled
}

export default useGetIsRolesTabEnabled
